import { render, staticRenderFns } from "./homemenu.vue?vue&type=template&id=f79fb1d0&scoped=true&"
import script from "./homemenu.vue?vue&type=script&lang=js&"
export * from "./homemenu.vue?vue&type=script&lang=js&"
import style0 from "./homemenu.vue?vue&type=style&index=0&id=f79fb1d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79fb1d0",
  null
  
)

export default component.exports